export default {
  qr_redeem: {
    text: 'Bonus + Deal entwerten',
    done: false,
  },
  guest_invite: {
    text: 'Einladung verschicken',
    done: false,
    pres: ['qr_redeem'],
  },
  profile_edit: {
    text: 'Profil bearbeiten',
    done: false,
  },
  profile_preview: {
    text: 'Profil Vorschau',
    done: false,
    pres: ['profile_edit'],
  },
  profile_stat_visits: {
    text: 'Besucher anzeigen',
    done: false,
    pres: ['profile_edit'],
  },
  profile_stat_tours: {
    text: 'Touren anzeigen',
    done: false,
    pres: ['profile_stat_visits'],
  },
  profile_stat_reviews: {
    text: 'Bewertungen anzeigen',
    done: false,
    pres: ['profile_stat_tours'],
  },
  profile_stat_favorites: {
    text: 'Follower anzeigen',
    done: false,
    pres: ['profile_stat_reviews'],
  },
  deal_preview: {
    text: 'Deal Vorschau',
    done: false,
  },
};
